import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class NightingaleDeliveryStatus extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateStatus);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateStatus);
  }

  updateStatus = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newStatus = event.detail.data.html.querySelector('nightingale-delivery-status');

    if (!newStatus) {
      this.remove();
      return;
    }

    morph(this, newStatus, { childrenOnly: true });
    this.className = newStatus.className;
  };
}

if (!customElements.get('nightingale-delivery-status')) {
  customElements.define('nightingale-delivery-status', NightingaleDeliveryStatus);
}
